(() => {
  if (customElements.get('qrs-electronic-zoom')) return;
  class QrsElectronicZoom extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      queueMicrotask(() => this.init());
    }
    init() {
      if (!this.isConnected || this.initialized) return;
      this.range = this.querySelector('[data-zoom-range]');
      this.toggle = this.querySelector('[data-zoom-toggle]');
      this.beam = this.querySelector('[data-zoom-beam]');
      this.spot = this.querySelector('[data-zoom-spot]');
      if (!this.range || !this.toggle || !this.beam || !this.spot) return;
      this.initialized = true;
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.requested = !this.reduce.matches;
      this.inView = false;
      this.phase = Math.acos(1 - .18 * 2);
      this.frame = 0;
      this.last = 0;
      this.onToggle = () => { this.requested = !this.requested; this.sync(); };
      this.onInput = () => {
        this.requested = false;
        const value = Number(this.range.value) / 100;
        this.phase = Math.acos(1 - value * 2);
        this.paint(value);
        this.sync();
      };
      this.onVisibility = () => this.sync();
      this.onRangeFocus = () => { this.requested = false; this.sync(); };
      this.onReduced = () => { if (this.reduce.matches) this.requested = false; this.sync(); };
      this.toggle.addEventListener('click', this.onToggle);
      this.range.addEventListener('input', this.onInput);
      this.range.addEventListener('focus', this.onRangeFocus);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.reduce.addEventListener('change', this.onReduced);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.sync();
      }, { threshold: .15 });
      this.observer.observe(this);
      this.querySelector('.qrs-zoom__controls').hidden = false;
      this.paint(.18);
      this.sync();
    }
    paint(value) {
      const t = Math.min(1, Math.max(0, value));
      this.beam.style.transform = `scaleY(${.12 + t * .88})`;
      this.spot.style.transform = `scale(${.18 + t * .82})`;
      this.range.value = String(Math.round(t * 100));
    }
    sync() {
      this.toggle.textContent = this.dataset[this.requested ? 'pause' : 'play'];
      this.toggle.setAttribute('aria-pressed', String(this.requested));
      const run = this.requested && this.inView && !document.hidden && this.isConnected;
      if (run && !this.frame) { this.last = 0; this.frame = requestAnimationFrame(time => this.tick(time)); }
      if (!run && this.frame) { cancelAnimationFrame(this.frame); this.frame = 0; this.last = 0; }
      this.dataset.running = String(run);
    }
    tick(time) {
      if (!this.requested || !this.inView || document.hidden || !this.isConnected) { this.frame = 0; this.sync(); return; }
      if (this.last) this.phase += Math.min(time - this.last, 60) * Math.PI * 2 / 10000;
      this.last = time;
      this.paint((1 - Math.cos(this.phase)) / 2);
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      cancelAnimationFrame(this.frame);
      this.observer.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.reduce.removeEventListener('change', this.onReduced);
      this.toggle.removeEventListener('click', this.onToggle);
      this.range.removeEventListener('input', this.onInput);
      this.range.removeEventListener('focus', this.onRangeFocus);
      this.initialized = false;
    }
  }
  customElements.define('qrs-electronic-zoom', QrsElectronicZoom);
})();
